import { memo } from 'react';
import classes from './index.module.css';

function Page404Screen() {
  return <h1 className={classes.header}>Page Not Found!</h1>;
}

export default memo(Page404Screen);
